module.exports = __webpack_public_path__ + "static/media/back_to_list.043cc347.svg";